import React from "react";
import { useSelector } from 'react-redux';
import LightGreenTick from "../../assets/images/svgs/LightGreenTick.svg?react"

import "./SuccessMessage.css"

const SuccessMessage = () => {
  const successMessage = useSelector(state => state.orderDetails.successMessage);
  const showSuccessMessage = useSelector(state => state.orderDetails.showSuccessMessage);

  return (
    <div className="successMessageDiv">
      <LightGreenTick />
      {showSuccessMessage && <>{successMessage}</>}
    </div>
  );
};

export default SuccessMessage;
